/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { CodeEnum } from 'client-code/sls-service-endpoints';
import { ErrorTypes } from './ErrorTypes';
import { PreSignInError } from './PreSignInError';

export class SlsGlobalEndpointError extends PreSignInError {
    TAG: string = 'SlsGlobalEndpointError';

    constructor(code: string, message: string) {
        super(code, message);
        this.message = message;
        this.setCode(code);
    }

    private setCode(code: string) {
        switch (code) {
            case CodeEnum.ApigwError:
                this.code = ErrorTypes.SLS_API_GATEWAY_ERROR_C151;
                this.type = CodeEnum.ApigwError;
                break;
            case CodeEnum.InvalidRequest:
                this.code = ErrorTypes.SLS_INVALID_REQUEST_ERROR_C152;
                this.type = CodeEnum.InvalidRequest;
                break;
            case CodeEnum.NotFound:
                this.code = ErrorTypes.SLS_NOT_FOUND_ERROR_C153;
                this.type = CodeEnum.NotFound;
                break;
            default:
                this.code = ErrorTypes.SLS_UNKNOWN_ERROR_C154;
                this.type = 'SLS_GLOBAL_UNKNOWN_ERROR';
        }
    }
}
